import { createStore } from 'vuex'
import modules from './modules'


import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';
import state from './state'
// import admission from './modules/admission'
// import school from './modules/school'

// export default createStore ({
//   modules:{
//     admission,
//     school

//   }
// })

const store = createStore({
  modules,
  state,
  actions,
  mutations,
  getters 
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  // strict: process.env.NODE_ENV !== 'production',
})

export default store

